<template>
  <router-view />
</template>

<script>
export default {
  name: 'IrRefundsWrapper',
};
</script>
